export const state = {
    cache: true,
    sessionStorageKey: 1, // TODO: P1 - dynamic to clear cache on operator update
    activeParentType: "directory",
    isDirectoryFilterActive: false,
    activeView: "grid",
    activeMarker: null,
    categories: [],
    sidebarOpen: true,
    tripPlannerActive: false,
    operatorData: [],
    tripPlannerData: [],
    activeCategories: [],
    selected: {
      directory: [],
      accessible: false,
      petFriendly: false,
      subcategories: []
    },
    googleMapStateKey: 0,
    googleMapRouteStateKey: 0,
    googleMapMarkerCluster: null,
    isLoading: true,
    tripPlannerOperators: [],
    tripPlannerPageId: "5309", // TODO: dynamic
}